<template>
  <div class="dean-switch-container">
    <label class="dean-switch">
      <div :class="deanSwitchClass" @click="valueChanged"></div>
    </label>
  </div>
</template>

<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

// COMPONENTS
@Component({})
export default class deanInputSwitch extends Vue {
  @Prop({ default: false }) checked!: boolean;
  @Prop({ default: 'checkbox' }) label!: string;
  @Prop({ default: 'checkbox-id' }) id!: string;
  @Prop({ default: false }) disabled!: boolean;

  // DATA
  value: boolean = false;

  // COMPUTED
  get deanSwitchClass() {
    let value = 'slider';
    if (this.value) value += ` checked`;
    if (this.disabled) value += ` disabled`;
    if (this.disabled && this.value) value += ` disabled-checked`;
    return value;
  }

  @Watch('checked')
  checkedChanged() {
    this.value = this.checked;
  }

  // METHODS
  valueChanged() {
    if (this.disabled == false) {
      console.log(this.checked);
      console.log(this.value);
      this.value = !this.value;
      console.log(this.value);

      this.$emit('checked', {
        id: this.id,
        label: this.label,
        value: this.value
      });
    }
  }

  mounted() {
    this.checkedChanged();
  }
}
</script>

<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

.dean-switch-container {
  display: inline-flex;
  height: 40px;
  width: 70px;
  text-transform: lowercase;
  font-weight: normal;
  align-content: center;
  justify-content: space-between;
  padding: 5px 10px 5px 10px;
}

.dean-switch {
  display: inline-flex;
  position: relative;
  width: 50px;
  height: 30px;
  input {
    display: none;
  }
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--color-light, $color-light);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  @include border-radius(30px);
  &:hover {
    outline: none;
    background-position: left bottom;
    box-shadow: 0px 0px 10px 2px var(--color-secondary, $color-secondary);  
  }
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  @include border-radius(50%);
  @include box-shadow(2px 0px 5px rgba(0, 0, 0, 0.15));
}

input:hover + .slider:before {
  outline: none;
  background-position: left bottom;
  // box-shadow: 0px 0px 10px 2px themed('color-switch');
  box-shadow: 0px 0px 10px 2px var(--color-info-success, $color-info-success);
}

/*
input:checked + .slider {
  background-color: var(--color-secondary, $color-secondary);
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
  @include box-shadow(-2px 0px 5px rgba(0, 0, 0, 0.15));
}
*/

.checked {
  //background-color: themed('color-switch');
  background-color: var(--color-info-success, $color-info-success);
  &:hover + .slider:before {
    outline: none;
    background-position: left bottom;
    // box-shadow: 0px 0px 10px 2px themed('color-switch');
    box-shadow: 0px 0px 10px 2px var(--color-info-success, $color-info-success);
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.05) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.05) 50%,
    rgba(255, 255, 255, 0.05) 75%,
    transparent 75%,
    transparent
    );
    background-size: 25px 25px;
    animation: move 2s linear infinite;
  }
}

.checked.slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
  @include box-shadow(-2px 0px 5px rgba(0, 0, 0, 0.15));
}

.disabled:hover {
  cursor: not-allowed;
}

.disabled-checked {
  background-color: var(--color-dark-shade-4, $color-dark-shade-4);
}

</style>
